import React, { FC } from 'react'
import { displayPrice } from 'helpers'
import { Fonts } from 'components/base-ui'
import styled from 'styled-components'

interface ProductPriceProps {
  totalPrice: number
  priceBeforeDiscount: number
  discount: number
  customClassName?: string
}

const ProductPrice: FC<ProductPriceProps> = ({ totalPrice, priceBeforeDiscount, discount, customClassName = '' }) => {
  const fullPrice = `฿${displayPrice(totalPrice / 100)}`
  const fullPriceBeforeDiscount = discount ? `฿${displayPrice(priceBeforeDiscount / 100)}` : 0
  return (
    <Fonts.H2 className={customClassName}>
      {discount > 0 && <Discount>{fullPriceBeforeDiscount}</Discount>}
      {fullPrice}
    </Fonts.H2>
  )
}

export default ProductPrice

const Discount = styled.span`
  margin-right: 5px;
  color: ${(props) => props.theme.colors.baseGrey};
  text-decoration: line-through;
  font-size: 14px;
`
